var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5H32V25.4743H0V5Z",
    fill: "#CB000F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7141 15.8048C10.7124 14.8241 10.9851 13.8625 11.5014 13.0287C12.0176 12.1948 12.7568 11.522 13.6354 11.0863C14.514 10.6506 15.497 10.4693 16.4732 10.5629C17.4495 10.6566 18.38 11.0215 19.1598 11.6163C18.2924 10.5357 17.111 9.751 15.7786 9.37056C14.4462 8.99013 13.0286 9.03271 11.7214 9.49243C10.4142 9.95214 9.28204 10.8063 8.4811 11.937C7.68016 13.0677 7.25 14.4192 7.25 15.8048C7.25 17.1905 7.68016 18.542 8.4811 19.6727C9.28204 20.8034 10.4142 21.6576 11.7214 22.1173C13.0286 22.577 14.4462 22.6196 15.7786 22.2391C17.111 21.8587 18.2924 21.074 19.1598 19.9934C18.38 20.5882 17.4495 20.9531 16.4732 21.0468C15.497 21.1404 14.514 20.9591 13.6354 20.5234C12.7568 20.0877 12.0176 19.4149 11.5014 18.581C10.9851 17.7472 10.7124 16.7856 10.7141 15.8048V15.8048Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4911 12.5587L22.114 14.2616L24.234 13.2444L23.114 15.313L24.7425 17.0159L22.4283 16.593L21.3083 18.6616L20.994 16.3302L18.6797 15.9073L20.7997 14.8902L20.4911 12.5587Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/TR.b769fbb9.svg";
export { ForwardRef as ReactComponent };